import {Component, inject, Input, OnInit} from "@angular/core";
import {DropdownComponent} from "../../dropdown/dropdown.component";
import {CommonModule} from "@angular/common";
import {Store} from "@ngrx/store";
import {LibOptionValue} from "daisy-design-system-front";
import {firstValueFrom, Observable, switchMap} from "rxjs";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MultiSelectModule} from "primeng/multiselect";
import {selectStationOptions, selectStationOptionsByUids} from '../../../../store/stations/stations.selectors';
import {TranslateModule} from '@ngx-translate/core';
import {CheckboxModule} from '../../form-field/checkbox/checkbox.module';
import {map, startWith, tap} from 'rxjs/operators';
import _ from "lodash";
import {Popover} from 'primeng/popover';
import {DialogService} from '@gnv-shared/service';

@Component({
  selector: "app-select-stations",
  templateUrl: "./select-stations.component.html",
  styleUrls: ["./select-stations.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    DropdownComponent,
    MultiSelectModule,
    FormsModule,
    CheckboxModule,
    ReactiveFormsModule,
    Popover
  ],
})
export class SelectStationsComponent implements OnInit {
  @Input() valueFormControl = new FormControl<string[] | null>(null);
  @Input() showAllStationsForm = new FormControl<boolean>(false, { nonNullable: true });

  public stationView$!: Observable<LibOptionValue<string>[]>;
  public excludeStations: LibOptionValue<string>[] = [];
  public showCheckbox = true;

  private lasCheckboxValue!: boolean;
  private includeStationIds: string[] = [];

  private readonly store = inject(Store);
  private readonly dialogService = inject(DialogService);

  ngOnInit(): void {
    this.initialize();
  }

  private initialize() {
    this.lasCheckboxValue = this.showAllStationsForm?.value ?? false;
    this.stationView$ = this.showAllStationsForm
      .valueChanges
      .pipe(
        startWith(this.lasCheckboxValue),
        switchMap(showAllStations => {
          return this.store.select(selectStationOptions(showAllStations))
            .pipe(
              tap(stations => {
                if (!showAllStations) {
                  const stationIds = stations.map(station => station.value);
                  const excludeStationIds = _.difference(this.valueFormControl.value, stationIds);
                  this.includeStationIds = _.intersection(this.valueFormControl.value, stationIds) ?? [];
                  this.updateExcludeStation(excludeStationIds);
                }
              })
            );
        })
      );
  }

  private updateExcludeStation(stationIds: string[]): void {
    firstValueFrom(this.store.select(selectStationOptionsByUids(stationIds)))
      .then(response => {
        this.excludeStations = response;
      })
  }

  private askConfirmation(checked: boolean): Observable<boolean> {
    return this.dialogService
      .openConfirmStationDisplay(checked)
      .pipe(map(result => result.accept));
  }

  private refreshCheckboxUI() {
    this.showCheckbox = false;
    setTimeout(() => {
      this.showCheckbox = true;
    });
  }

  protected update(checked: boolean) {
    firstValueFrom(this.askConfirmation(checked))
      .then(accepted => {
        if (!accepted) {
          // rollback
          this.lasCheckboxValue = !checked;
          this.showAllStationsForm.patchValue(this.lasCheckboxValue, { emitEvent: true });
        } else {
          // confirmation
          this.lasCheckboxValue = checked;

          if (!checked) {
            this.valueFormControl.setValue(this.includeStationIds);
          }
        }

        this.refreshCheckboxUI();
      })
  };

}
